module.exports = __webpack_public_path__ + "img/AU.b35a142d.svg";